import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
const PIXEL_ID = '1154323073507518';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <div className="min-h-screen bg-depto-cream font-sans selection:bg-depto-amber selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <StorySection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}